import messagesApi from '../../api/messages'
// initial state
const state = {
  inboxMessages: [],
  requestMessages: [],
  outboxMessages: [],
  archiveMessages: [],
  unreadCount: 0,
  unreadRequestCount: 0,
  groupedRecipients: [],
  employeeRecipients: [],
};

const getters = {
  unreadRequests: state => {
    return state.requestMessages.slice().filter(r => {
      if (!r.read) {
        return r;
      }
    }).length;
  },
  recentFirstInbox: state => {
    return state.inboxMessages.slice().sort((a, b) => {
      return new Date(b.sentAt) - new Date(a.sentAt);
    });
  },
  recentFirstRequests: state => {
    return state.requestMessages.slice().sort((a, b) => {
      return new Date(b.sentAt) - new Date(a.sentAt);
    });
  },
  recentFirstOutbox: state => {
    return state.outboxMessages.slice().sort((a, b) => {
      return new Date(b.sentAt) - new Date(a.sentAt);
    });
  },
  recentFirstArchive: state => {
    return state.archiveMessages.slice().sort((a, b) => {
      return new Date(b.sentAt) - new Date(a.sentAt);
    });
  },
  groupedRecipients: state => {
    return [
      state.groupedRecipients.filter(g => g.type == 'employeePositionGroup'),
      state.groupedRecipients.filter(g => g.type == 'usertypeGroup'),
      state.groupedRecipients.filter(g => g.type == 'individualManager'),
      state.groupedRecipients.filter(g => g.type == 'managedLocationGroup'),
      state.groupedRecipients.filter(
        g => g.type == 'managedClientLocationGroup',
      ),
      state.groupedRecipients.filter(g => g.type == 'locationGroup'),
      state.groupedRecipients.filter(g => g.type == 'clientLocationGroup'),
      state.groupedRecipients.filter(g => g.type == 'individual'),
    ].flat(Infinity);
  },
};

const actions = {
  getGroupedRecipients({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      messagesApi.getGroupedRecipients(
        recipients => {
          commit('setGroupedRecipients', recipients);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  getEmployeeRecipients({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      messagesApi.getEmployeeRecipients(
        employeeRecipients => {
          commit('setEmployeeRecipients', employeeRecipients);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  getInbox({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.getInbox(
        {
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setInboxMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  searchInbox({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.searchInbox(
        {
          search_term: payload.searchTerm,
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setInboxMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  getRequests({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.getRequests(
        {
          page: payload.page,
          limit: payload.limit,
          search_term: payload.searchTerm,
        },
        res => {
          commit('setRequestMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  searchRequests({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.searchRequests(
        {
          search_term: payload.searchTerm,
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setRequestMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  getUnreadCount({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      messagesApi.getUnreadCount(
        count => {
          commit('setUnreadCount', count.count);
          resolve(count);
        },
        error => {
          console.log('Something broke at the API');
          reject(error);
        },
      );
    });
  },

  getUnreadRequestCount({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      messagesApi.getUnreadRequestCount(
        count => {
          commit('setUnreadRequestCount', count.count);
          resolve(count);
        },
        error => {
          console.log('Something broke at the API');
          reject(error);
        },
      );
    });
  },

  getOutbox({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.getOutbox(
        {
          page: payload.page,
          limit: payload.limit,
          search_term: payload.searchTerm,
        },
        res => {
          commit('setOutboxMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject(error);
        },
      );
    });
  },

  searchOutbox({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.searchOutbox(
        {
          search_term: payload.searchTerm,
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setOutboxMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  getArchive({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.getArchive(
        {
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setArchiveMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  searchArchive({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      messagesApi.searchArchive(
        {
          search_term: payload.searchTerm,
          page: payload.page,
          limit: payload.limit
        },
        res => {
          commit('setArchiveMessages', res.messages);
          resolve(res);
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  send({commit}, messageParams) {
    return new Promise((resolve, reject) => {
      messagesApi.create(
        messageParams,
        message => {
          resolve();
        },
        error => {
          console.log('Could not send message');
          reject();
        },
      );
    });
  },

  sendToManager({commit}, messageParams) {
    return new Promise((resolve, reject) => {
      messagesApi.createManagerMessage(
        messageParams,
        message => {
          resolve();
        },
        error => {
          console.log('Could not send message');
          reject();
        },
      );
    });
  },

  shiftInquiry({commit}, messageParams) {
    return new Promise((resolve, reject) => {
      messagesApi.sendShiftIniquiry(
        messageParams,
        message => {
          resolve();
        },
        error => {
          console.log('Could not send message');
          reject();
        },
      );
    });
  },

  markRead({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markRead(
        messageId,
        message => {
          commit('updateMessage', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as read');
          reject();
        },
      );
    });
  },

  markArchived({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markArchived(
        messageId,
        message => {
          commit('addMessageToArchive', message);
          commit('removeMessageFromInbox', message);
          commit('removeMessageFromOutbox', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as archived');
          reject();
        },
      );
    });
  },

  markInbox({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markInbox(
        messageId,
        message => {
          commit('addMessageToInbox', message);
          commit('removeMessageFromArchive', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as inboxes');
          reject();
        },
      );
    });
  },

  markUnread({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markUnread(
        messageId,
        message => {
          commit('updateMessage', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as unread');
          reject();
        },
      );
    });
  },

  markFlagged({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markFlagged(
        messageId,
        message => {
          commit('updateMessage', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as flagged');
          reject();
        },
      );
    });
  },

  markUnflagged({commit}, messageId) {
    return new Promise((resolve, reject) => {
      messagesApi.markUnflagged(
        messageId,
        message => {
          commit('updateMessage', message);
          resolve();
        },
        error => {
          console.log('Could not mark this message as unflagged');
          reject();
        },
      );
    });
  },
};

const mutations = {
  setUnreadCount(state, count) {
    state.unreadCount = count;
  },

  setUnreadRequestCount(state, count) {
    state.unreadRequestCount = count;
  },

  setInboxMessages(state, messages) {
    state.inboxMessages = messages;
  },

  setRequestMessages(state, messages) {
    state.requestMessages = messages;
  },

  setOutboxMessages(state, messages) {
    state.outboxMessages = messages;
  },

  setArchiveMessages(state, messages) {
    state.archiveMessages = messages;
  },

  setGroupedRecipients(state, recipients) {
    state.groupedRecipients = recipients;
  },

  setEmployeeRecipients(state, recipients) {
    state.employeeRecipients = recipients;
  },

  removeMessageFromInbox(state, message) {
    state.inboxMessages = [
      ...state.inboxMessages.filter(m => m.id !== message.id),
    ];
  },
  removeMessageFromOutbox(state, message) {
    state.outboxMessages = [
      ...state.outboxMessages.filter(m => m.id !== message.id),
    ];
  },

  removeMessageFromArchive(state, message) {
    state.archiveMessages = [
      ...state.archiveMessages.filter(m => m.id !== message.id),
    ];
  },

  addMessageToInbox(state, message) {
    state.inboxMessages = [...state.inboxMessages, message];
  },

  addMessageToArchive(state, message) {
    state.archiveMessages = [...state.archiveMessages, message];
  },

  updateMessage(state, message) {
    state.inboxMessages = [
      ...state.inboxMessages.filter(m => m.id !== message.id),
      message,
    ];
    state.archiveMessages = [
      ...state.archiveMessages.filter(m => m.id !== message.id),
      message,
    ];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
